import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext } from "react";
import "./graph-connection-builder.scss";
import { GraphNode } from "../GraphNode/GraphNode";
import { FlowContext } from "../../contexts/FlowContext";
import { ShimmerLoader } from "../../../../../core/coreComponents/ShimmerLoader/ShimmerLoader";
export const GraphConnectionBuilder = ({ isLoading, }) => {
    const flowContext = useContext(FlowContext);
    const { flowState, setFlowState, setSelectedEntitiesSet } = flowContext || {};
    const handleNodeChange = useCallback((newFlow) => {
        setFlowState === null || setFlowState === void 0 ? void 0 : setFlowState(newFlow);
    }, [setFlowState]);
    return (_jsx("div", { className: "flex justify-center align-center height-100vh", children: _jsx("div", { className: "graph-connection-container", children: isLoading ? (_jsx(ShimmerLoader, {})) : (flowState === null || flowState === void 0 ? void 0 : flowState.map((graphNodeData, index) => (_jsx(GraphNode, { onChange: handleNodeChange, nodeIndex: index, graphNodeData: graphNodeData }, graphNodeData.id)))) }) }));
};
